import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconNoTransformation = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinejoin: "round",
	strokeMiterlimit: 2,
	clipRule: "evenodd",
	viewBox: "0 0 14 14",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M3.733 0v3.733H0V0zM0 5.133h3.733v3.734H0zm0 5.134h3.733V14H0zM5.133 14v-3.733h3.734V14zm5.134 0v-3.733H14V14zM14 8.867h-3.733V5.133H14zm0-5.134h-3.733V0H14zM8.867 0v3.733H5.133V0zm0 5.133v3.734H5.133V5.133z"
	})
});
export default SvgIconNoTransformation;
